import React from 'react';

export default function Button({siteId, children, ...props}) {
  return (
    <button className={`poll-button poll-button--${siteId}`} {...props}>
      {children}
    </button>
  )
}
